export default "__VITE_ASSET__Dh2KZF8w__"